import React, { useState, useEffect } from "react";
import { useHistory, Link, useParams } from "react-router-dom";
import { XCircle, Save } from "react-feather";
import { POST, PUT, FILE, GET } from "../../../api/adminApi";
import { toast } from "react-toastify";
import { Image } from "react-bootstrap";

export default function BulkNotificationCreateUpdate() {
  const history = useHistory();
  const { id } = useParams();
  const [title, setTitle] = useState("");
  const [msg, setMsg] = useState("");
  const [phones, setPhones] = useState("");
  const [imageUrl, setImageUrl] = useState("");
  /* eslint-disable no-unused-vars */
  const [imageFile, setImageFile] = useState(null);
  /* eslint-enable no-unused-vars */

  useEffect(() => {
    async function getItem() {
        const response = await GET(`/services/admin/api/bulk-notification/${id}`);
        if (response) {
            setTitle(response.titleText || "");
            setMsg(response.messageText || "");
            setPhones(Array.isArray(response.phones) ? response.phones.join(", ") : response.phones || "");
            setImageUrl(response.imageUrl || "");
        }
     }

    if (id) {
        getItem();
    }
  }, [id]);

  function handleTitleChange(e) {
    setTitle(e.target.value);
  }

  function handleMessageChange(e) {
    setMsg(e.target.value);
  }

  function handlePhonesChange(e) {
    setPhones(e.target.value);
  }

  function handleImageChange(e) {
    if (e.target.files && e.target.files[0]) {
        setImageFile(e.target.files[0]);
        // Upload immediately or on save?
        // Usually better to upload on selection or on save. 
        // Let's upload immediately to get URL or just preview. 
        // But for this API, it seems separate upload endpoint: POST /api/bulk-notification-image-upload
        uploadImage(e.target.files[0]);
    }
  }

  async function uploadImage(file) {
      const formData = new FormData();
      formData.append("image", file);
      const response = await FILE("/services/admin/api/bulk-image-upload", formData);

      if (response) {
          if (typeof response === "string") {
              setImageUrl(response);
              toast.success("Изображение загружено");
          } else {
              const url = response.url || response.imageUrl || (response.data && response.data.url);
              if (url) {
                  setImageUrl(url);
                  toast.success("Изображение загружено");
              }
          }
      }
  }

  function onSubmit(e) {
    e.preventDefault();

    if (!title) {
        toast.error("Введите заголовок");
        return;
    }

    if (!msg) {
      toast.error("Введите сообщение");
      return;
    }

    // Convert comma-separated string to array of strings and trim whitespace
    const phoneList = phones
      .split(",")
      .map((phone) => phone.trim())
      .filter((phone) => phone !== "");

    if (phoneList.length === 0) {
      toast.error("Введите номера телефонов");
      return;
    }

    // Validation
    for (let i = 0; i < phoneList.length; i++) {
        // Basic validation, maybe user allows different formats, but keeping same as SMSBulk for consistency if needed.
        // SMSBulk: starts with 998, no +, length 12 via code.
        // User didn't specify validation rules, but generally safe to assume similar rules.
        // However, I will be less strict unless I know for sure.
        // But let's keep it simple: no empty strings.
    }

    const payload = {
        titleText: title,
        messageText: msg,
        phones: phoneList,
        imageUrl: imageUrl
    };

    if (id) {
        // Update
        update(payload);
    } else {
        // Create
        create(payload);
    }
  }

    async function create(payload) {
      const response = await POST("/services/admin/api/bulk-notification", payload);
      if (response?.success) {
        history.push("/admin/bulk-notification");
        toast.success("Успешно добавлено");
      }
    }

    async function update(payload) {
        const updatePayload = {
            ...payload,
            id: parseInt(id)
        };
        const response = await PUT("/services/admin/api/bulk-notification", updatePayload);
        if (response?.success) {
          history.push("/admin/bulk-notification");
          toast.success("Успешно обновлено");
        }
      }

  return (
    <div className="mb-1 mx-3 ">
      <h3 className="mb-5 mt-5">{id ? "Редактировать" : "Создать"} рассылку по номерам</h3>
      <form onSubmit={onSubmit} autoComplete="off">
        <div
          className="admin-card p-4 pt-12 d-flex flex-column justify-content-between"
          style={{ minHeight: "70vh" }}
        >
          <div className="mb-1 d-flex flex-column">
              <div className="d-flex align-items-center mb-2 gap-2">
                <label
                  style={{ width: "120px" }}
                  className="color-grey text-end text-nowrap"
                >
                  Заголовок
                </label>
                <div>
                  <input
                    value={title}
                    name="title"
                    className="input-control"
                    onChange={handleTitleChange}
                    style={{ width: "300px" }}
                    required
                  />
                </div>
              </div>
              
              <div className="d-flex align-items-center mb-2 gap-2">
                <label
                  style={{ width: "120px" }}
                  className="color-grey text-end text-nowrap"
                >
                  Сообщение
                </label>
                <div>
                  <textarea
                    value={msg}
                    name="message"
                    className="input-control"
                    onChange={handleMessageChange}
                    style={{ width: "300px", minHeight: "100px" }}
                    required
                  />
                </div>
              </div>

              <div className="d-flex align-items-center mb-2 gap-2">
                <label
                  style={{ width: "120px" }}
                  className="color-grey text-end text-nowrap"
                >
                  Картинка
                </label>
                <div>
                  <input
                    type="file"
                    className="form-control"
                    onChange={handleImageChange}
                    style={{ width: "300px" }}
                    accept="image/*"
                  />
                  {imageUrl && (
                      <div className="mt-2">
                          <Image
                            src={
                              imageUrl.startsWith("http")
                                ? imageUrl
                                : "https://bo.akfacomfort.uz" + imageUrl
                            }
                            fluid
                            style={{ maxHeight: "150px" }}
                            thumbnail
                          />
                      </div>
                  )}
                </div>
              </div>

              <div className="d-flex align-items-center mb-2 gap-2">
                <label
                  style={{ width: "120px" }}
                  className="color-grey text-end text-nowrap"
                >
                  Телефоны
                </label>
                <div>
                  <textarea
                    value={phones}
                    name="phones"
                    className="input-control"
                    onChange={handlePhonesChange}
                    placeholder="Введите номера телефонов через запятую"
                    style={{ width: "300px", minHeight: "100px" }}
                    required
                  />
                </div>
              </div>
          </div>

          <div className="d-flex justify-content-end">
            <Link to="/admin/bulk-notification" className="mr-3">
              <button className="btn text-white btn-bg-primary d-flex align-items-center">
                <XCircle size={14} className="mr-2" />
                Отмена
              </button>
            </Link>
            <button
              className="btn text-white btn-bg-success d-flex align-items-center"
              type="submit"
            >
              <Save size={14} className="mr-2" />
              Сохранить
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}
